module.exports = __webpack_public_path__ + "img/concat-code.8a4fa03c.png";